import * as PIXI from "pixi.js-legacy"

/**
 * pixi-timeout is a plugin which replicates the behaviour of window.setTimout
 * but uses PIXI.Ticker (requestAnimationFrame) as the method of progressing time
 * The bonus is that any timeouts will be paused and resumed automatically when
 * you call PIXI.Application.stop & PIXI.Application.start
 */
(function init(pixi)
{
    if (!pixi)
    {
        throw new Error("PIXI was not found")
    }

    if (!pixi.Ticker || !pixi.Ticker.shared)
    {
        throw new Error("PIXI.Ticker was not found")
    }
}(PIXI));

 /**
 * Sets a timeout.
 *
 * @param  {number}    secs  The seconds
 * @param  {Function}  cb    Callback function to fire after timeout
 * @return {object}    Timer state object
 */
export function pixiSetTimeout(secs, cb = ()=> {})
{
    let progress = 0;

    const ticker = ((delta) =>
    {
        progress += delta;

        const elapsed = progress / (60 * PIXI.Ticker.shared.speed);

        if (elapsed > secs) end(true);
    });

    const end = (fire) =>
    {
        PIXI.Ticker.shared.remove(ticker);

        if (fire) cb();
    };

    const clear = () =>
    {
        end(false)
    };

    const finish = () =>
    {
        end(true);
    };

    // start
    PIXI.Ticker.shared.add(ticker);

    return { clear, finish };
}

export function pixiSetTimeoutAsync(secs) {
    return new Promise(res => {
        pixiSetTimeout(secs, res);
    });
}

/**
 * Clears a timeout, preventing the function from being fired
 *
 * @param  {object}  timerObj  A timer state object
 */
export function pixiClearTimeout(timerObj)
{
    timerObj.clear()
}